module.exports = __webpack_public_path__ + "static/media/rua_al_hijrah_2.69ba8952.jpg";